// pages/FormViewerPage/components/CustomerInfoFields/NameField.tsx — Nama Lengkap field
import React, { useState } from 'react';
import PersonVcardIcon from '../../../../components/icons/PersonVcardIcon';
import type { CustomerInfoFieldsProps } from './types';
import { ms } from '../../../../locales/ms';
import { validateCustomerName } from '../../services/formViewerService/validation';

export const NameField: React.FC<CustomerInfoFieldsProps> = ({ form, customerData, fieldErrors, onCustomerDataChange }) => {
    if (!form.customerFields?.name?.visible) return null;
    const minName = form.customerFields?.name?.minLength || 3;
    const [touched, setTouched] = useState(false);
    const trimmed = customerData.name.trim();
    // Hijau ✓ hanya kalau panjang OK DAN isi valid (tanpa angka/alamat).
    const contentErr = trimmed ? validateCustomerName(customerData.name, minName) : null;
    const tooShort = trimmed.length > 0 && trimmed.length < minName;
    const liveContentErr = !tooShort && contentErr && trimmed.length >= minName ? contentErr : null;
    const isOk = trimmed.length >= minName && !contentErr;
    const showError = fieldErrors.name || (touched && liveContentErr);
    return (
        <div>
            <div className="flex justify-between items-center mb-0.5">
                <label htmlFor="field-name" className="flex items-center text-sm font-medium text-slate-700 dark:text-slate-300">
                    <PersonVcardIcon className="w-4 h-4 mr-1.5 text-orange-600 dark:text-orange-400" />
                    {ms(form, m => m.fullName, 'Nama Lengkap')} {form.customerFields?.name?.required && <span className="text-red-500">*</span>}
                </label>
                <span className={`text-xs ${isOk ? 'text-emerald-600 dark:text-emerald-400' : 'text-slate-500 dark:text-slate-400'}`}>
                    {customerData.name.length}/{minName} {ms(form, m => m.chars, 'karakter')} {isOk && '✓'}
                </span>
            </div>
            <input
                id="field-name"
                type="text"
                name="name"
                value={customerData.name}
                onChange={onCustomerDataChange}
                onBlur={() => setTouched(true)}
                placeholder={ms(form, m => m.fullNamePlaceholder, 'Nama Lengkap')}
                autoComplete="name"
                maxLength={25}
                className={`w-full p-2.5 rounded-lg bg-slate-100 dark:bg-slate-700 border-0 outline-none focus:ring-2 focus:ring-orange-500 transition-all ${showError ? 'ring-2 ring-red-400 dark:ring-red-500' : trimmed.length > 0 && trimmed.length < minName ? 'ring-2 ring-amber-400 dark:ring-amber-500' : ''}`}
                required={form.customerFields?.name?.required}
            />
            {showError ? (
                <p className="text-xs text-red-500 mt-0.5">{fieldErrors.name || liveContentErr}</p>
            ) : trimmed.length > 0 && trimmed.length < minName ? (
                <p className="text-xs text-amber-500 mt-0.5">{ms(form, m => m.nameTooShort, 'Nama terlalu pendek')}</p>
            ) : null}
        </div>
    );
};
